<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import MxIcon from './MxIcon.vue';

const route = useRoute();

const createPath = computed(() => {
  void route.path;
  const last =
    (typeof localStorage !== 'undefined' && localStorage.getItem('last_create_kind')) || 'video';
  return `/create/${last}`;
});

const sideTabs = computed(() => [
  { to: '/',        icon: 'Home',     label: 'Главная',  side: 'left'  as const },
  { to: '/ideas',   icon: 'Sparkles', label: 'Идеи',     side: 'left'  as const },
  { to: '/history', icon: 'History',  label: 'История',  side: 'right' as const },
  { to: '/profile', icon: 'User',     label: 'Профиль',  side: 'right' as const },
]);

const isActive = (to: string) =>
  to === '/' ? route.path === '/' : route.path.startsWith(to);
</script>

<template>
  <nav class="tabs">
    <RouterLink
      v-for="t in sideTabs.filter(t => t.side === 'left')"
      :key="t.to"
      :to="t.to"
      :class="['tab', { 'tab--active': isActive(t.to) }]"
    >
      <MxIcon :name="t.icon" :size="22" />
      <span class="lbl">{{ t.label }}</span>
    </RouterLink>

    <RouterLink :to="createPath" class="fab" :class="{ 'fab--active': route.path.startsWith('/create') }">
      <MxIcon name="Plus" :size="26" />
    </RouterLink>

    <RouterLink
      v-for="t in sideTabs.filter(t => t.side === 'right')"
      :key="t.to"
      :to="t.to"
      :class="['tab', { 'tab--active': isActive(t.to) }]"
    >
      <MxIcon :name="t.icon" :size="22" />
      <span class="lbl">{{ t.label }}</span>
    </RouterLink>
  </nav>
</template>

<style scoped>
.tabs {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  display: flex;
  align-items: center;
  background: var(--bg-elevated);
  border-top: 1px solid var(--hairline);
  padding: 8px 0 calc(8px + env(safe-area-inset-bottom));
  z-index: 50;
}
.tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 6px 0 2px;
  color: var(--text-tertiary);
  font-size: var(--fs-xs);
  font-weight: 500;
  position: relative;
  -webkit-tap-highlight-color: transparent;
  transition: color 0.18s ease;
}
.tab:active { transform: scale(0.94); transition: transform 0.08s ease; }
.tab--active { color: var(--accent); }
.tab--active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  width: 28px;
  height: 3px;
  border-radius: 0 0 var(--r-sm) var(--r-sm);
  background: var(--accent);
  transform: translateX(-50%);
}
.fab {
  flex: 0 0 56px;
  width: 56px;
  height: 56px;
  margin: -22px 12px 0;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background:
    radial-gradient(120% 120% at 30% 0%, #ffd86b 0%, transparent 60%),
    var(--accent);
  color: #000;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);
  transition: transform 0.12s ease;
}
.fab:active { transform: scale(0.94); }
@media (max-width: 340px) {
  .tab .lbl { display: none; }
}
</style>
